"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function CancelPage() {
  const router = useRouter();

  useEffect(() => {
    localStorage.setItem("giftcard_canceled", "true");
    router.replace("/carte-cadeau");
  }, [router]);

  return (
    <div className="min-h-screen bg-white">
      {/* Page de transition invisible */}
    </div>
  );
} 